module.exports = __webpack_public_path__ + "img/read.42ee1933.png";